export default {
  'earn': 'earn',
  'about': 'about',
  'about.Experience': 'Experience you can trust',
  'about.biconomy':
    'Biconomy is a global digital asset trading platform. We take pride in providing fully transparent exchange, listing and digital asset development services.',
  'about.ceo':
    'Our CEO, Dmitry Sheludko is an experienced, forward-thinking leader and strategist in the world of digital assets.He is an advisor in many cryptocurrency projects as well as in certain governmental bodies responsible for crypto regulations. He holds a degree in economics and psychology from Yale University.',
  'about.LinkedIn': 'LinkedIn Profile',
  'about.us': 'ABOUT US',
  'abou.us.title': 'From technology to business partners, we are proud to work with companies known globally.',
  'abou.us.text_1':
    'Biconomy is a cryptocurrency exchange platform that provides global cryptocurrency trading services for a number of digital assets.',
  'abou.us.text_2':
    'We believe in the ideology behind blockchain suggesting that technologies based on distributed ledger systems can help build foundational human trust, enhance transaction efficiency and have a positive influence on social and economic well-being.',
  'about.valus.1.title': 'Performance',
  'about.valus.1.desc': 'We think that strong performance is our core competence and that it should never be sacrificed.',
  'about.valus.2.title': 'Transparency',
  'about.valus.2.desc': 'We believe that we can build a trustworthy environment only through open processes and clear  communication.',
  'about.valus.3.title': 'Growth',
  'about.valus.3.desc': 'We believe in hard work and continuous development, so we do our best to move forward quickly.',
  'about.valus.4.title': 'Support',
  'about.valus.4.desc': 'We support not only our clients but also our partners and team members believing in the power of collaboration.',
  'about.values.title': 'Our values',
  'about.values.desc': 'We believe in the power of strong culture and firm values.',
  'about.cooperate title': 'We cooperate with industry leaders',
  'about.Ecosystem': 'Ecosystem Partners',
  'about.Media': 'Media Partners',
};
